import React, { FC } from 'react'
import { Box, Typography, keyframes, useTheme } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

const pulse = keyframes`
    0%, 100% { transform: scale(1); opacity: 0.7; }
    50% { transform: scale(1.1); opacity: 1; }
`

const dots = keyframes`
    0% { content: ''; }
    25% { content: '.'; }
    50% { content: '..'; }
    75% { content: '...'; }
`

const ThinkingIndicator: FC = () => {
    const theme = useTheme()

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                py: 1,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                    animation: `${pulse} 1.5s ease-in-out infinite`,
                }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 16, color: theme.palette.primary.contrastText }} />
            </Box>
            <Typography
                variant="caption"
                sx={{
                    color: 'text.secondary',
                    fontWeight: 500,
                    fontStyle: 'italic',
                    '&::after': {
                        content: '""',
                        animation: `${dots} 1.5s steps(4, end) infinite`,
                    },
                }}
            >
                Cleo está pensando
            </Typography>
        </Box>
    )
}

export default ThinkingIndicator